angular.module('app.api').factory('SalaryApi', [
  'api',
  function SalaryApi(api) {
    const salaryApi = {
      getCandidateSalary: (userId, latest = true) => {
        return api.get(`users/${userId}/salary?latest=${latest}`)
      },
      addCandidateSalary: (userId, payload) => {
        return api.post(`users/${userId}/salary`, payload)
      },
      updateCandidateSalary: (salaryId, payload) => {
        return api.put(`user/salary/${salaryId}`, payload)
      },
    }
    return salaryApi
  },
])



// WEBPACK FOOTER //
// ./scripts/shared/directives/lawyer-salary/salary.api.js